import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { IntegrationTokenDelegationBaseEffect } from './integration-token-delegation-base.effect';

@NgModule({
  imports: [ EffectsModule.forFeature([ IntegrationTokenDelegationBaseEffect ]) ]
})
export class IntegrationTokenDelegationBaseModule {}
